class ProductCardVariants {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleVariantClick.bind(this));
  }

  handleVariantClick(event) {
    const variantButton = event.target.closest('.variant-button:not(.view-details-button)');
    if (!variantButton) return;

    const container = variantButton.closest('.variant-buttons');
    const productCard = variantButton.closest('product-card');
    if (!container || !productCard) return;

    const productId = container.dataset.productId;
    const variantId = variantButton.dataset.variantId;
    const price = variantButton.dataset.price;
    const size = variantButton.textContent.trim().toLowerCase().replace(' ', '');

    this.updatePrice(productCard, price);
    this.updateVariantInput(productId, variantId);
    this.updateSelectedButton(container, variantButton);
    this.updateProductImage(productCard, size);
  }

  updatePrice(productCard, price) {
    const priceElement = productCard.querySelector('.price');
    if (priceElement) priceElement.textContent = price;
  }

  updateVariantInput(productId, variantId) {
    const variantInput = document.querySelector(`#product_form_${productId} [data-variant-input]`);
    if (variantInput) variantInput.value = variantId;
  }

  updateSelectedButton(container, selectedButton) {
    container.querySelectorAll('.variant-button').forEach(btn => btn.classList.remove('selected'));
    selectedButton.classList.add('selected');
  }

  updateProductImage(productCard, size) {
    const images = productCard.querySelectorAll('.product_featured_image, .product_second_media_image');
    const productHandle = productCard.getAttribute('product-handle');
    if (!productHandle) {
      console.error('Product handle not found');
      return;
    }

    images.forEach(img => {
      const originalSrc = img.getAttribute('data-original-src') || img.src;
      const newSrc = this.updateImageUrl(originalSrc, size);
      
      this.checkImageExists(newSrc)
        .then(exists => {
          if (exists) {
            this.setNewImage(img, newSrc, size);
          } else {
            console.log('Variant image not found, keeping original');
          }
        })
        .catch(error => {
          console.error('Error checking image:', error);
        });
    });
  }

  updateImageUrl(url, newSize) {
    return url.replace(
      /(\/files\/.*?)((-\d+ml)?)(\.\w+)/,
      (match, p1, p2, p3, p4) => `${p1}-${newSize}${p4}`
    );
  }

  checkImageExists(url) {
    return fetch(url, { method: 'HEAD' }).then(response => response.ok);
  }

  setNewImage(img, newSrc, size) {
    img.src = newSrc;

    if (img.srcset) {
      const newSrcset = img.srcset.split(',').map(src => {
        const [url, width] = src.trim().split(' ');
        return `${this.updateImageUrl(url, size)} ${width}`;
      }).join(', ');
      img.srcset = newSrcset;
    }

    img.style.opacity = '0';
    setTimeout(() => {
      img.style.opacity = '1';
    }, 50);
  }
}

new ProductCardVariants();